import { roleGuardCanActivate, authedGuardCanActivate } from '@app/core';
import { Route } from '@angular/router';
import { MsalRedirectComponent } from '@azure/msal-angular';
import { roles } from './core/configs/auth.config';

export const ROUTES: Route[] = [
    {
        path: 'operator',
        loadChildren: () =>
            import('./features/operator/operator.routes').then(
                (r) => r.OPERATOR_ROUTES
            ),
        // TODO: we'll need to update this once we have MSAl configured
        canActivate: [roleGuardCanActivate],
        data: {
            expectedRole: [roles.Agent],
            overrideRole: [roles.Admin, roles.Developer],
        },
    },
    {
        path: 'admin',
        loadChildren: () =>
            import('./features/admin/admin.routes').then((r) => r.ADMIN_ROUTES),
        canActivate: [roleGuardCanActivate],
        data: {
            expectedRole: [roles.Admin],
            overrideRole: [roles.Developer],
        },
    },
    {
        path: 'home',
        loadComponent: () =>
            import('./features/home/home.component').then(
                (c) => c.HomeComponent
            ),
        canActivate: [authedGuardCanActivate],
    },
    {
        // Needed for handling redirect after login
        path: 'auth',
        component: MsalRedirectComponent,
    },
    {
        path: '',
        redirectTo: 'operator',
        pathMatch: 'full',
    },
    { path: '**', redirectTo: '' },
];
